import { CAPABILITY_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { ICapabilityRepository } from "../domain/repositories/ICapabilityRepository";
import { CapabilityActionRequestModel } from "./models/CapabilityActionRequestModel";
import { CapabilityDetailResponseModel } from "./models/CapabilityDetailResponseModel";
import { CapabilityRequestModel } from "./models/CapabilityRequestModel";
import { CapabilityResponseModel } from "./models/CapabilityResponseModel";

@injectable()
export class CapabilityImpl implements ICapabilityRepository {
  async getList(
    params: CapabilityRequestModel,
  ): Promise<ListBaseApiResponseModel<CapabilityResponseModel>> {
    return await client?.get(CAPABILITY_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: CapabilityRequestModel,
  ): Promise<BaseApiResponseModel<CapabilityDetailResponseModel>> {
    return await client?.get(CAPABILITY_MANAGEMENT.DETAIL, params);
  }

  async create(
    body: CapabilityActionRequestModel,
  ): Promise<BaseApiResponseModel<CapabilityDetailResponseModel>> {
    return await client?.post(CAPABILITY_MANAGEMENT.CREATE, body);
  }

  async update(
    body: CapabilityActionRequestModel,
  ): Promise<BaseApiResponseModel<CapabilityDetailResponseModel>> {
    return await client?.put(CAPABILITY_MANAGEMENT.UPDATE, body);
  }

  async delete(
    params: CapabilityRequestModel,
  ): Promise<BaseApiResponseModel<CapabilityDetailResponseModel>> {
    return await client?.delete(CAPABILITY_MANAGEMENT.DELETE, params);
  }
}
